import React, { Component } from "react";
import { connect } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import { helperFunctions as HF} from 'helper/helperFunctions';
import Select from 'react-select';
import { Button } from "react-bootstrap";
import MessageCom from "layouts/Dashboard/Message";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";


class EmailTemplateFormPage extends Component {
	constructor(props){
    	super(props);
    	this.validator = new SimpleReactValidator();
    	const { emailTemplate } = this.props;
    	console.log('emailTemplate', emailTemplate);
    	this.state = {
    		emailTemplate : emailTemplate,
    		submitted : false,
    		flagTestEmail : false,
			value: "",
    	}
    	this.onChange   =  this.onChange.bind(this);
    	this.submitForm = this.submitForm.bind(this);
    	this.handleChangeRole = this.handleChangeRole.bind(this);
    	this.onChangeCK = this.onChangeCK.bind(this);
    	this.handleChangeTemplate = this.handleChangeTemplate.bind(this);
	}
	flagForTestEmail = (e) => {
		const { checked } = e.target;
		this.setState({flagTestEmail:checked}, ()=>{
			if (!checked){
				this.setState({emailTemplate:{...this.state.emailTemplate, testEmail:''}})
			}
		})
	}
	handleChangeTemplate(selectedOptionType, info){
		// console.log('selection option type', selectedOptionType);
		// console.log('selection info', info);
		// console.log('email templates after template chanfe', this.props.emailTemplates[selectedOptionType['count']]);
		if (info['action'] === 'select-option') {
			this.setState({emailTemplate:this.props.emailTemplates[selectedOptionType['count']]})
			// const emailTemplateDropDown = { ...this.state.emailTemplate };
			// emailTemplateDropDown['mail_templates_id'] = this.props.emailTemplates[selectedOptionType['value']];
			// this.setState({ emailTemplate: emailTemplateDropDown });
		}
	}

	onChange(e){
		const { name, value, type } = e.target;
	    const emailTemplateState = { ...this.state.emailTemplate };
	    emailTemplateState[name] = type === 'checkbox' ? e.target.checked ? 1 : 0 : value;
	    this.setState({emailTemplate: emailTemplateState});
	}
	submitForm(e, updateAndSend){
	    e.preventDefault();
	    if (this.validator.allValid()) {
			this.setState({submitted: true}, function(){
				if ( this.props.formType === 'generate' ){
					this.props.handleEmailTempSubmit(this.state.emailTemplate, this.props.formType, this.props.actionObject, updateAndSend);
				}
				else{
					this.props.handleEmailTempSubmit(this.state.emailTemplate, this.props.formType);
				}
			});
		} else {
			this.setState({submitted: false});
			this.validator.showMessages();
			this.forceUpdate();
		}
	}
	handleChangeRole(selectedOptionType, info){
		if (info['action'] === 'select-option') {
			const emailTemplateDropDown = { ...this.state.emailTemplate };
			emailTemplateDropDown['mail_templates_id'] = selectedOptionType['value'];
			this.setState({ emailTemplate: emailTemplateDropDown });
		}
	}
	onChangeCK(content){
      var newContent = content;
	  const emailTemplateState = { ...this.state.emailTemplate };
	  emailTemplateState['html_template'] = newContent;
	  this.setState({emailTemplate: emailTemplateState});
    }
	
	handleChange = (value) => {
        this.setState({ value });
    };
	render(){
		
		const modules = {
			toolbar: [
				[{ header: [1, 2, 3, false] }],  // Heading levels
				["bold", "italic", "underline", "strike"],  // Text styles
				[{ list: "ordered" }, { list: "bullet" }],  // Lists
				[{ script: "sub" }, { script: "super" }],  // Subscript/Superscript
				[{ indent: "-1" }, { indent: "+1" }],  // Indentation
				[{ align: [] }],  // Text alignment
				["blockquote", "code-block"],  // Block styles
				[{ color: [] }, { background: [] }],  // Text color & background
				["link", "image", "video"],  // Media options
				["clean"],  // Remove formatting
			],
		};
		
		const formats = [
			"header", "bold", "italic", "underline", "strike",
			"list", "bullet", "script", "indent", "align",
			"blockquote", "code-block", "color", "background",
			"link", "image", "video"
		];
		this.validator.purgeFields();
		const { emailTemplate, flagTestEmail  } = this.state;
		const { mailTypes, formType, buttonName, adminType, mailTemplatesDD } = this.props;
		return(
			<div className="content">
				<form  id="email-template-form">
					{
			        	formType === 'generate' && mailTemplatesDD.length> 0 &&
				        <div className='form-group'>
					      	<label htmlFor="name">Select Template<span className="requiredClass">*</span></label>
					      	<Select
								value={HF.returnLabelWithValue(emailTemplate.id, mailTemplatesDD)}
								onChange={this.handleChangeTemplate}
								options={mailTemplatesDD}
								isSearchable={true}
								isMulti={false}
								name='mail_templates_id'
								placeholder={'Select Template'}
								isDisabled={formType === 'edit'?true:false}
								tabIndex={null}
			                />
			                
					    </div>
			        }
					<div className="form-group">
			        	<label>Subject</label>
			          	<input className="form-control" value={emailTemplate.subject} onChange={this.onChange} name="subject"/>
			          	{this.validator.message('subject', emailTemplate.subject, 'required')}
			        </div>
			        <div className="form-group">
			        	<label>Template</label>
						<div
                    style={{
                        resize: "vertical",
                        overflow: "hidden",
                        height: this.state.editorHeight,
                    }}
                >
						<ReactQuill
							value={emailTemplate.html_template} 
							onChange={this.onChangeCK} 
							modules={modules}
							formats={formats}
							className="p10 customizedEditor" 
						/>
</div>
						{/* <CKEditor
							editor={ ClassicEditor }
							// config={ {
							// 	licenseKey: '<YOUR_LICENSE_KEY>', // Or 'GPL'.
							// 	plugins: [ Essentials, Paragraph, Bold, Italic, FormatPainter ],
							// 	toolbar: [ 'undo', 'redo', '|', 'bold', 'italic', '|', 'formatPainter' ],
							// 	initialData: '<p>Hello from CKEditor 5 in React!</p>',
							// } }
						/> */}
			          	{/* <CKEditor 
				        	activeClass="p10" 
				          	content={emailTemplate.html_template} 
				          	events={{
				            	// "blur": this.onBlur,
				            	// "afterPaste": this.afterPaste,
				            	"change": this.onChangeCK,
				          	}}
				        /> */}
			          	{this.validator.message('html_template', emailTemplate.html_template, 'required')}
			        </div>
			        {
			        	formType !== 'generate' &&
				        <div className='form-group'>
					      	<label htmlFor="name">Select Role<span className="requiredClass">*</span></label>
					      	<Select
								value={HF.returnLabelWithValue(emailTemplate.mail_templates_id, mailTypes)}
								onChange={this.handleChangeRole}
								options={mailTypes}
								isSearchable={true}
								isMulti={false}
								name='mail_templates_id'
								placeholder={'Select Role'}
								isDisabled={formType === 'edit'?true:false}
			                />
			                {this.validator.message('mailTemplates', emailTemplate.mail_templates_id, 'required')}
					    </div>
			        }
			        
			        {
			        	( formType !== 'generate' ) &&
			        	<React.Fragment>
					        <div className="form-group">
					        	<label className="container-check">
					        	<input type="checkbox" className="form-control" value={emailTemplate.default} onChange={this.onChange} name="default" checked={emailTemplate.default?true:false}/>
					        	<span className="checkmark"></span>
					        	Default</label>
					          	{
					          		this.validator.message('default', emailTemplate.default, 'required')
					          	}
					        </div>
					        <div className="form-group">
					        	<label className="container-check">
					        	<input type="checkbox" className="form-control" value={flagTestEmail} onChange={this.flagForTestEmail} checked={flagTestEmail?true:false}/>
					        	<span className="checkmark"></span>
					        	Test Email</label>
					        </div>
				        </React.Fragment>
			        }
			        {
			        	flagTestEmail &&
				        <div className="form-group">
				        	<label>Test Email</label>
				          	<input className="form-control" value={emailTemplate.testEmail } onChange={this.onChange} name="testEmail"/>
				          	{this.validator.message('testEmail', emailTemplate.testEmail, 'required|email')}
				        </div>
			        }
				    <div className="text-center">
				    	{
				    		flagTestEmail
				    		?
				    			<Button onClick={(e)=>this.submitForm(e, 0)} form="email-template-form" className="backButton pt-sm no_radius pb-sm success btn btn-lg btn-info ml-sm mt-sm" >{buttonName} and Send Email</Button>
				    		:
				    			<Button onClick={(e)=>this.submitForm(e, 0)} form="email-template-form" className="backButton pt-sm no_radius pb-sm success btn btn-lg btn-info ml-sm mt-sm" >{ buttonName }</Button>	
				    	}	
						

						{
							/*
			        		formType === 'generate' &&
			        		<Button onClick={(e)=>this.submitForm(e, 1)} form="email-template-form" className="ml-sm backButton pt-sm no_radius pb-sm success btn btn-lg btn-info ml-sm mt-sm" >Update & Send</Button>
			        		*/
			        	}
					</div>
					<div className="row">
				    	<div className="col-md-12">
				      		<div>
				        		<MessageCom/>
				      		</div>
				    	</div>
				  	</div>
				</form>
			</div>
		);
	};
}


function mapStateToProps(state) {
    const { adminType } = state.adminReducer;
    return {
        adminType
    };
}

// Quill toolbar configuration

const EmailTemplateForm = connect(mapStateToProps)(EmailTemplateFormPage);
export default EmailTemplateForm;



// WEBPACK FOOTER //
// ./src/components/Admin/EmailTemplates/EmailTemplateForm.jsx